import { Flower2 } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

// La fecha sale de los datos de la boda. Antes estaba escrita aquí y se
// quedaba anunciando el día viejo cada vez que se cambiaba en el panel.
function shortDate(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return `${pad(d.getDate())} · ${pad(d.getMonth() + 1)} · ${d.getFullYear()}`;
}

export default function Marquee({ wedding, content }) {
  const t = content?.texts || {};
  const phrases = [
    wedding?.couple,
    // Si los novios dejan el campo vacío, la fecha se calcula sola.
    t.marquee_date?.trim() || shortDate(wedding?.date_iso),
    t.marquee_word_1,
    t.marquee_word_2,
  ].filter(Boolean);

  return (
    <div className="overflow-hidden bg-sand border-y border-nude py-5" data-testid="marquee-ribbon" aria-hidden="true">
      <div className="marquee-track flex whitespace-nowrap">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {[0, 1].map((r) =>
              phrases.map((text, i) => (
                <span key={`${r}-${i}`} className="flex items-center">
                  <span className="font-serif italic text-2xl sm:text-3xl font-light text-olive px-8">
                    {text}
                  </span>
                  <Flower2 className="h-4 w-4 text-bronze shrink-0" strokeWidth={1.25} />
                </span>
              ))
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
